e360.service('facebookApi', [
   '$http', 'apiHelper',
   function ($http, apiHelper) {
      return {
         getConfig: function (eventId) {
            var url = 'events/' + eventId + '/fbpage';
            return apiHelper.get(url);
         },
         getLoginUri: function(eventId, returnUrl) {
            return apiHelper.getApiUrl('events/' + eventId + '/fbpage/login', {returnUrl: returnUrl});
         },
         postToFacebook: function (eventId) {
            var url = apiHelper.getApiUrl('events/' + eventId + '/fbpage/post');
            return $http.post(url)
               .catch(function (response) {
                  switch (response.status) {
                     case 400:
                        return "You've already posted this event to Facebook.";
                     case 500:
                        return "Sorry, there was a problem posting to Facebook.";
                  }
                  return "";
               });
         }
      };
   }
]);
